// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentfulBreakoutBanner-module__wrapper--bKEHg","logoWrapper":"ContentfulBreakoutBanner-module__logoWrapper--SHjsV"};